export default __webpack_public_path__ + "static/icon-33-6-1fe3a94619267219e8c73ad818a28dee.png";